module.exports = __webpack_public_path__ + "img/ic_arrow.2a1c7910.svg";